import React from 'react';
import c from 'classnames';

interface IframeComponentProps {
  src?: string;
  srcDoc?: string;
  onLoad?: () => void;
  onError?: () => void;
  className?: string;
  containerClassName?: string;
  style?: React.CSSProperties;
  height?: string;
}

const IframeComponent: React.FC<IframeComponentProps> = (props) => {
  const {
    src,
    srcDoc,
    onLoad,
    onError,
    className,
    containerClassName,
    style,
    height = '400px',
  } = props;
  return (
    <div className={c('my-32 flex w-full !justify-center !items-center', containerClassName)}>
      <iframe
        allowFullScreen
        className={c(
          'block w-full max-w-[96rem] !mx-auto',
          { 'rounded-8 shadow-02': !srcDoc },
          className,
        )}
        height={height}
        loading="lazy"
        sandbox="allow-scripts allow-popups allow-top-navigation-by-user-activation allow-forms allow-same-origin"
        src={src}
        srcDoc={srcDoc}
        style={style}
        title="embed"
        onError={onError}
        onLoad={onLoad}
      />
    </div>
  );
};

export default IframeComponent;
